import { gql } from "@apollo/client";
import { metaResolveType, createPageInfo } from "./helper";

export const typeDef = gql`
  type TrackResult {
    result: Boolean
  }

  union RecommendMeta = EpisodeMeta | LiveMeta | TVShowMeta

  type RecommendConnection @cacheControl(scope: PRIVATE, maxAge: 0) {
    elementId: String
    data: [RecommendMeta]
    pageInfo: PageInfo
  }

  type Mutation {
    track(location: String!, referrer: String, sid: String): TrackResult
  }

  type Query {
    recommend(location: String!, elementIds: [String!]): [RecommendConnection]
  }
`;

export const resolvers = {
  Mutation: {
    track: async (
      _parent,
      { location, referrer, sid },
      { req, dataSources }
    ) => {
      try {
        const options = (() => {
          if (sid) {
            return { "_rt.sid": sid };
          }
          return null;
        })();

        await dataSources.rtoaster.track(location, referrer, options);
        return { result: true };
      } catch (e) {
        console.log(e);
        return { result: false };
      }
    },
  },
  Query: {
    recommend: async (
      _parent,
      { location, elementIds },
      { req, dataSources }
    ) => {
      try {
        const response = await dataSources.rtoaster.recommend(
          location,
          elementIds
        );

        if (response?.result) {
          const result = response.result
            .map((v) => {
              // こう言う形で入ってくるので加工する
              // {
              //   attributes: {
              //     elementId: 'rt_detail_user_auto_10',
              //     sessionId: 'P38ddfa39298f7f70001174e0000001400000000412c302a'
              //   },
              //   '$value': '<div>63988</div>'
              // }
              const elementId = elementIds.find(
                (elId) => !!~v.attributes.elementId.indexOf(elId)
              );
              const matched = v["$value"].match(/(?<id>\d+)/);
              const value = Number(matched.groups.id);
              return {
                elementId: elementId,
                rtsid: v.attributes.sessionId,
                id: value,
              };
            })
            .reduce((acc, v) => {
              // elementIdごとにまとめる
              if (!acc[v.elementId]) {
                acc[v.elementId] = [];
              }
              acc[v.elementId].push({
                id: v.id,
                rtsid: v.rtsid,
              });
              return acc;
            }, {});

          const promises = Object.keys(result).map(async (elementId) => {
            const ids = result[elementId].map((v) => v.id);
            const { metas } = await dataSources.meta.searchFromId(ids);

            const metasWithRtsid = result[elementId]
              .map(({ id, rtsid }) => {
                const meta = metas.find((meta) => meta.id === id);
                if (meta) {
                  return { ...meta, rtsid };
                } else {
                  return null;
                }
              })
              .filter((x) => !!x);

            return {
              elementId,
              data: metasWithRtsid,
              pageInfo: createPageInfo({
                offset: 0,
                limit: metasWithRtsid.length,
                count: metasWithRtsid.length,
              }),
            };
          });

          return await Promise.all(promises);
        }
      } catch (e) {
        console.log("rtoaster recommend error", e);
      }
    },
  },
  RecommendMeta: {
    __resolveType: metaResolveType,
  },
};
